const VERSION = "0.3.2";

export { VERSION };
